import { render } from "./banner-forum.vue?vue&type=template&id=b867ed52&ts=true"
import script from "./banner-forum.vue?vue&type=script&lang=ts"
export * from "./banner-forum.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__